import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

import { UsersHookFormSelect } from "../../components";
import { useScannerHelper } from "../../helpers";
import { useUserHookFormList } from "../../components/UsersHookFormSelect";
import { getUserLocation } from "../../redux";
import { connect } from "react-redux";

const CreateReworkEmployeeId = ({ locationId = 1 }) => {
  const { setValue } = useFormContext();
  const { users } = useUserHookFormList({ locationId });

  const setEmployeeId = (barcode) => {
    const user = users?.find((u) => u?.employeeId === barcode);
    if (user?.id) setValue("userId", user.id);
  };

  useScannerHelper(setEmployeeId);

  return (
    <UsersHookFormSelect label="Employee" locationId={locationId} required />
  );
};

const mapStateToProps = (state) => ({
  locationId: getUserLocation(state),
});
export default connect(mapStateToProps)(CreateReworkEmployeeId);
